import api from './client';
import {  Menu, MenuDraft } from './types';

export const getMenu = async (): Promise<Menu[]> => {
  const response = await api.get('menu/');
  return response.data;
};

export const addFoodToMenu = async (menu: MenuDraft) => {
  const response = await api.post('menu/', [menu]);
  return response.data;
};

export const deleteFoodFromMenu = async (externalId: string) => {
  const response = await api.delete(`menu/${externalId}`);
  return response.data;
}
